export const _forms = {
  title: {
    login: `Sign in to VeriTooth`,
  },
  copy: {
    login: ``,
  },
  actions: {
    login: `requestLogin`,
    registerPatient: `requestRegisterPatient`,
    registerDentist: `requestRegisterDentist`,
    reset: `requestResetPassword`,
    confirm: `requestConfirmPassword`,
  },
  submit: {
    login: `Sign In`,
    register: `Create Account`,
    register_dentist: `Create Account`,
    reset: `Request Reset`,
    confirm: `Set Password`,
  },
};

export const login = {
  email: {
    label: `Email Address`,
    labelHidden: true,
    type: `email`,
    errorLabel: `Email`,
    placeholder: `Enter your Email`,
    autoComplete: `user email`,
    validations: {
      required: true,
      email: true,
    },
  },
  password: {
    label: `Password`,
    labelHidden: true,
    type: `password`,
    autoComplete: `current-password`,
    placeholder: `Enter your Password`,
    validations: {
      required: true,
    },
    forgot: true,
  },
};

export const registerPatient = {
  first_name: {
    type: `text`,
    label: `First Name`,
    labelHidden: true,
    placeholder: `First Name`,
    autoComplete: `given-name`,
    validations: {
      required: true,
    },
  },
  last_name: {
    type: `text`,
    label: `Last Name`,
    labelHidden: true,
    placeholder: `Last Name`,
    autoComplete: `family-name`,
    validations: {
      required: true,
    },
  },
  email: {
    label: `Email`,
    labelHidden: true,
    placeholder: `Email`,
    autoComplete: `user email`,
    type: `email`,
    errorLabel: `Email`,
    validations: {
      required: true,
      email: true,
    },
  },
  password: {
    label: `Password`,
    labelHidden: true,
    placeholder: `Create Password`,
    helper: true,
    autoComplete: `new-password`,
    type: `password`,
    validations: {
      required: true,
      min: 6,
    },
  },
  confirmPassword: {
    label: `Confirm Password`,
    labelHidden: true,
    placeholder: `Confirm Password`,
    type: `password`,
    autoComplete: `new-password`,
    validations: {
      required: true,
      min: 6,
      match: `password`,
    },
    errorMessages: {
      match: `Passwords do not match`,
    },
  },
};

export const registerDentist = {
  specialty: {
    type: `select`,
    items: [],
    label: `Select Your Speciality`,
    labelHidden: true,
    placeholder: `Select Your Speciality`,
    validations: {
      required: true,
    },
  },
  first_name: {
    type: `text`,
    label: `First Name`,
    labelHidden: true,
    placeholder: `First Name`,
    validations: {
      required: true,
    },
  },
  last_name: {
    type: `text`,
    label: `Last Name`,
    labelHidden: true,
    placeholder: `Last Name`,
    validations: {
      required: true,
    },
  },
  email: {
    label: `Email Address`,
    labelHidden: true,
    placeholder: `Email Address`,
    autoComplete: `user email`,
    type: `email`,
    errorLabel: `Email`,
    validations: {
      required: true,
      email: true,
    },
  },
  password: {
    label: `Password`,
    labelHidden: true,
    placeholder: `Create Password`,
    helper: true,
    autoComplete: `password`,
    type: `password`,
    validations: {
      required: true,
      min: 6,
    },
  },
  confirmPassword: {
    label: `Confirm Password`,
    labelHidden: true,
    placeholder: `Confirm Password`,
    type: `password`,
    autoComplete: `new-password`,
    validations: {
      required: true,
      min: 6,
      match: `password`,
    },
    errorMessages: {
      match: `Passwords do not match`,
    },
  },
};

export const reset = {
  email: {
    type: `email`,
    label: `Email Address`,
    labelHidden: true,
    errorLabel: `Email`,
    placeholder: `Enter your Email`,
    validations: {
      required: true,
      email: true,
    },
  },
};

export const confirm = {
  new_password: {
    label: `Password`,
    labelHidden: true,
    type: `password`,
    placeholder: `Enter your Password`,
    validations: {
      required: true,
      min: 6,
    },
  },
  confirm_password: {
    label: `Confirm`,
    labelHidden: true,
    type: `password`,
    placeholder: `Enter your Password`,
    validations: {
      required: true,
      min: 6,
      match: `new_password`,
    },
  },
};

export const resetPassword = {
  current_password: {
    label: `Current Password`,
    labelHidden: true,
    placeholder: `Enter current password`,
    type: `password`,
    autoComplete: `current-password`,
    heading: {
      heading: `Current Password`,
      level: `h4`,
    },
    validations: {
      required: true,
    },
    forgot: true,
  },
  new_password: {
    heading: {
      heading: `New Password`,
      level: `h4`,
      tag: `h3`,
    },
    label: `New Password`,
    labelHidden: true,
    helper: true,
    type: `password`,
    placeholder: `New Password`,
    autoComplete: `new-password`,
    validations: {
      required: true,
      min: 6,
    },
  },
  confirmPassword: {
    label: `Confirm Password`,
    labelHidden: true,
    placeholder: `Confirm Password`,
    type: `password`,
    autoComplete: `new-password`,
    validations: {
      required: true,
      min: 6,
      match: `new_password`,
    },
    errorMessages: {
      match: `Passwords do not match`,
    },
  },
};

export const tourPaths = {
  dentist: [
    `dashboard-profile-info`,
    `dashboard-dentist-locations`,
  ],
  reviewer: [
    `dashboard-profile-info`,
    `dashboard-dentist-locations`,
    `dashboard-reviewer-application`,
  ],
};



// WEBPACK FOOTER //
// ./client/models/auth/index.js